import React from 'react'

import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import RangkumanPage from 'app/KinerjaPenilikPegawaiPage/pages/Perencanaan/Rangkuman'
import PageGuardPenilikPegawai from 'app/KinerjaPenilikPegawaiPage/components/PageGuardPenilikPegawai'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-penilik-pegawai-enabled'] || false
    const enabledPerencanaan =
      toggle?.['kinerja-penilik-pegawai-perencanaan-enabled'] || false

    if (!enabled || !enabledPerencanaan) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const Page: KinerjaApp = () => (
  <PageGuardPenilikPegawai>
    <RangkumanPage />
  </PageGuardPenilikPegawai>
)

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  centered: true,
}

export default Page
